import React from "react";
import { cn } from "@/utils";
import { ps } from "@components/ui/typography/typography.module.css";

interface CtaSupportTextProps extends React.HTMLProps<HTMLParagraphElement> {}

const CtaSupportText: React.FC<CtaSupportTextProps> = ({ className, children, ...props }) => {
  return (
    <p className={`${ps} ${cn("mt-4", className)}`} {...props}>
      {children}
    </p>
  );
};

export default CtaSupportText;
